// **************************************************
// IMAGE SERVICE
// **************************************************
//
// Very similar to AssetService, uses same manifest
// and group structure, but uses Image.onload to preload
// images for later use.
//
// The idea is to use AssetService to load a group
// (including images) into cache, then load that same
// group with ImageService immediately after to make
// them ready to use.
//
// // load
// await AssetService.load(assetManifest, 'some_group_name', 2)
// await ImageService.load(assetManifest, 'some_group_name', 2)
//
// // get an <image>
// ImageService.get('bg')
//
// **************************************************
import Queue from 'src/helpers/Queue'
import EventEmitter from 'src/helpers/EventEmitter'
import AssetService from 'src/services/AssetService'

const Events = {
  GROUP_COMPLETED: 'groupCompleted',
  COMPLETED: 'completed'
}

class ImageService {
  constructor () {
    Object.assign(this, EventEmitter, {
      groups: {},
      images: {},
      complete: false
    })
  }

  _loadItem = url => {
    return new Promise(resolve => {
      let image = new window.Image()
      this.images[url] = image
      image.onload = resolve
      image.crossOrigin = 'anonymous'

      // GET FROM ASSET SERVICE
      let asset = AssetService.getAsset(url)
      if (asset && asset.blobUrl) {
        // image.src = URL.createObjectURL(asset.blob)
        image.src = asset.blobUrl
      } else {
        image.src = url
      }
    })
  }

  _loadGroup = (concurrency, group) => {
    return new Promise(resolve => {
      let q = new Queue(concurrency)
      this.groups[group.id] = {}
      let item = this.groups[group.id]

      for (const url of group.urls) {
        if (!/\.(gif|jpe?g|png)$/i.test(url)) continue
        q.add(() => {
          return this._loadItem(url)
        })
      }

      q.on(Queue.Events.EMPTY, () => {
        item.loaded = true
        this.emit(Events.GROUP_COMPLETED, group.id)
        resolve()
      })
    })
  }

  load = (manifest, concurrency = 2, groupId = '') => {
    return new Promise(resolve => {
      let q = new Queue(1)

      for (const group of manifest) {
        if (group.id !== groupId && groupId !== '') continue
        console.log(`IMAGE LOAD GROUP ${group.id}`)

        q.add(() => {
          return this._loadGroup(concurrency, group)
        })
      }

      q.on(Queue.Events.EMPTY, () => {
        this.complete = true
        this.emit(Events.COMPLETED)
        console.log(`ImageService loaded`)
        resolve()
      })
    })
  }

  get = url => {
    return this.images[url]
  }
}

let service = new ImageService()
service.Events = Events
window.ImageService = service
export default service